<template>
    <div class="w-full md:px-6 px-2">
    <div class="tile is-ancestor mx-auto mt-8 md:flex space-x-2 ">
    <div class="tile is-vertical is-8 card-content">
      <div class="tile">
         <div class="tile is-parent is-vertical">

        </div>
   <!--      <div class="tile is-parent">
          <article class="tile is-child notification is-info">
    
            <figure class="">
              <img class="h-full w-full rounded overflow-hidden shadow" :url="'https://open-edu-bb.de/'" :src="'https://myedubbosz01.s3.eu-central-1.amazonaws.com/logo_Edu_trans_dda26c22e7.png'" />
            </figure>
          </article>
        </div> -->
        <!-- <source :type="mp4"> -->
      </div>
  
    <div class="tile card-content card">
      <div class="tile is-child notification is-warning is-vertical">
        
        <br>
        <h2 class="title">Wie werden die Contentmodule geprüft und wie kann ich selbst ein Contentmodul zur eduBB hinzufügen?</h2>
            <br>
            <div class="video">
            <video controls class="video-width">
            <source 
                :src="'https://myedubbosz01.s3.eu-central-1.amazonaws.com/Hilfe_QMS_01_2be19aa860.mp4'" 
                :type="mp4"/>
            Sorry, your browser doesn't support embedded videos.
            </video>
            </div>
            <div class="flex items-center">
            HOW TO:&nbsp;
            <font-awesome-icon class="red-color" icon="fa-file-pdf" />
            <a :href="'https://myedubbosz01.s3.eu-central-1.amazonaws.com/Hilfe_Autoren_01_beff55d88c.pdf'" target="_blank">&nbsp;
                Tutorial Anleitung
            </a>
            </div>
        
      </div>
    </div>
    <br>
  
      <div class="tile card-content card">
        <article class="tile is-child notification is-success">
          <p class="title">Kurs auf eduBB erstellen!</p>
          <p class="subtitle">Aligned with the right tile</p>
          <div class="content">                  
            <div class="video">
              <video controls class="video-width">
              <source 
                :src="'https://myedubbosz01.s3.eu-central-1.amazonaws.com/Hilfe_Autoren_02_fe3daffbac.mp4'"    
                />
              Sorry, your browser doesn't support embedded videos.
              </video>
            </div>
              <div class="flex items-center">
              HOW TO:&nbsp;
            <font-awesome-icon class="red-color" icon="fa-file-pdf" />
              <a :href="'https://myedubbosz01.s3.eu-central-1.amazonaws.com/Hilfe_Autoren_02_69ee462efb.pdf'" target="_blank">&nbsp;
                Tutorial Anleitung
              </a>
            </div>
          </div>
        </article>
      </div>
      <div class="tile card-content card">
      <div class="tile is-child notification is-danger is-vertical">
        
        <br>
        <h2 class="title">Was sind CC-Lizenzen und wie verwende ich die Lizenz in eduBB?</h2>
            <br>
            <div class="flex items-center">
            HOW TO:&nbsp;
            <font-awesome-icon class="red-color" icon="fa-file-pdf" />
            <a :href="'https://edubb-prod-v3-serv0.onrender.com/uploads/Hilfe_Autoren_CC_Lizenzen_1_a36c7d9615.pdf'" target="_blank">&nbsp;
                CC Lizenz Anleitung
            </a>
            </div>
      </div>
    </div>
    <br>
    </div>
<!--      <div class="tile is-parent mx-auto mt-8 md:flex space-x-2 card">
      <article class="tile is-child notification is-notification card-content">
        <div class="content">
          <p class="title">Neuigkeiten</p>
          <p class="subtitle">Weitere Tutorials</p>
          <div class="content">
          
          </div>
        </div>
      </article>
    </div> -->
  </div>
  
  </div>
  </template>
  
  <script>
  
  // import CourseOnboarding from '../components/CourseOnboarding.vue';
  /* import HeroSection from '../components/HeroSection.vue'
  import FeaturedSection from '../components/FeaturedSection.vue' */
  
  export default {
    name: "Documentation",
    components: {
    },
    data: function() {
      return {
        user: JSON.parse(localStorage.getItem("user"))
        ? JSON.parse(localStorage.getItem("user"))
        : { role: { name: 0 } },
        tab: "Metrics",
        API_URL:
          process.env.NODE_ENV == "production"
            ? process.env.VUE_APP_STRAPI_API_URL
            : "localhost:1338",
      };
    },

    methods: {
  /*     activeTab(element) {
        if (element === "Metrics") {
          this.tab = "Metrics";
        } else if (element === "Notifications") {
          this.tab = "Notifications";
        } else if (element === "Annoucements") {
          this.tab = "Annoucements";
        }
      }, */
    },
  
  /*  apollo: {
      modules: {
        query: gql`
          query {
            modules {
              id
              name
              description
              media {
                id
                name
                mime
                url
              }
            }
          }
        `,
      },
   } */
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  @import url("https://unpkg.com/tailwindcss@^2/dist/tailwind.min.css");
  body {
    font-family: "Lato", sans-serif;
    text-align: left;
  }
  .checkbox:checked {
    border: none;
  }
  .checkbox:checked + .check-icon {
    display: flex;
  }
  .color-blue {
    color: #0047ab;
  }
  .image {
      height: 200px;
  }
  .video {
      margin-top: 5rem;
      margin-bottom: 5rem;
  }
  .video-width {
      width: 100%;
  }
  
  @media (max-width: 700px) {
      .long {
          max-width: 100%;
          flex-basis: 100%;
      }
      .image {
          width: 100%;
          height: 100%;
      }
  }
  </style>
  